import i18n from '../lang/i18n';

const errorExtractor = {
    /**
     * Convert the value of the from to a well indented block of text
     */
    extract: (errors) => {
        var readableErrorList = [];

        for(var key in errors) {
            if (errors.hasOwnProperty(key)) {
                if(typeof errors[key] !== 'object') {
                    readableErrorList.push({
                        field: key,
                        msg: i18n.t(key) + " - " + i18n.t(errors[key])
                    });
                } else if (typeof errors[key] === 'object') {
                    readableErrorList = readableErrorList.concat(getObjectErrors(errors[key]));
                }
            }
        }

        return readableErrorList;
    }
}

/**
 * Get errors from an object
 */
 const getObjectErrors = (errorObject) => {
    var readableErrorToReturn = [];

    for(var key in errorObject) {
        if (errorObject.hasOwnProperty(key)) {
            if(key.toLowerCase().indexOf("specify") > 0) {
                readableErrorToReturn.push({
                    field: key,
                    msg: i18n.t("specify") + " - " + i18n.t(errorObject[key])
                });
            }
            else if(typeof errorObject[key] === 'object') {
                readableErrorToReturn = readableErrorToReturn.concat(getObjectErrors(errorObject[key]));
            }
            else {
                readableErrorToReturn.push({
                    field: key,
                    msg: i18n.t(key) + " - " + i18n.t(errorObject[key])
                });
            }
        }
    }

    return readableErrorToReturn;
}

export default errorExtractor;